import { useState } from 'react';

export default function Contact() {
  const [status, setStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setStatus('loading');
    const form = e.currentTarget;
    const data = new URLSearchParams();
    Array.from(form.elements).forEach((el) => {
      const input = el as HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement;
      if (input.name && input.value) {
        data.append(input.name, input.value);
      }
    });
    try {
      const res = await fetch('https://readdy.ai/api/form/d757qb4prit363gl109g', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: data.toString(),
      });
      if (res.ok) {
        setStatus('success');
        form.reset();
      } else {
        setStatus('error');
      }
    } catch {
      setStatus('error');
    }
  };

  return (
    <section id="contact" className="bg-[#080808] py-20 md:py-28 px-6">
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-14">
          <span className="text-[#00FF88] text-sm font-bold uppercase tracking-widest">Contáctanos</span>
          <h2 className="text-3xl md:text-4xl font-black text-white mt-3">¿Tienes alguna pregunta?</h2>
          <p className="text-gray-400 mt-4 text-base leading-relaxed">
            Escríbenos y te responderemos a la brevedad posible.
          </p>
          <div className="mt-4 w-16 h-1 bg-gradient-to-r from-[#00FF88] to-[#FF6B35] rounded-full mx-auto"></div>
        </div>

        <div className="bg-[#111] border border-white/5 rounded-2xl p-8 md:p-10">
          {status === 'success' ? (
            <div className="text-center py-10">
              <div className="w-16 h-16 flex items-center justify-center bg-[#00FF88]/10 rounded-full mx-auto mb-4">
                <i className="ri-check-line text-3xl text-[#00FF88]"></i>
              </div>
              <h3 className="text-white text-xl font-black mb-2">¡Mensaje enviado!</h3>
              <p className="text-gray-400 text-sm">Te responderemos pronto. ¡Gracias por contactarnos!</p>
              <button
                onClick={() => setStatus('idle')}
                className="mt-6 text-[#00FF88] text-sm font-bold hover:underline cursor-pointer whitespace-nowrap"
              >
                Enviar otro mensaje
              </button>
            </div>
          ) : (
            <form
              onSubmit={handleSubmit}
              data-readdy-form
              id="contact-form"
              className="flex flex-col gap-6"
            >
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
                <div className="flex flex-col gap-2">
                  <label className="text-gray-400 text-sm font-medium">Nombre</label>
                  <input
                    type="text"
                    name="name"
                    required
                    placeholder="Tu nombre completo"
                    className="bg-[#1a1a1a] border border-white/10 rounded-xl px-4 py-3 text-white text-sm placeholder-gray-600 focus:outline-none focus:border-[#00FF88]/50 transition-colors"
                  />
                </div>
                <div className="flex flex-col gap-2">
                  <label className="text-gray-400 text-sm font-medium">Email</label>
                  <input
                    type="email"
                    name="email"
                    required
                    placeholder="tu@correo.com"
                    className="bg-[#1a1a1a] border border-white/10 rounded-xl px-4 py-3 text-white text-sm placeholder-gray-600 focus:outline-none focus:border-[#00FF88]/50 transition-colors"
                  />
                </div>
              </div>
              <div className="flex flex-col gap-2">
                <label className="text-gray-400 text-sm font-medium">Asunto</label>
                <input
                  type="text"
                  name="subject"
                  required
                  placeholder="¿En qué podemos ayudarte?"
                  className="bg-[#1a1a1a] border border-white/10 rounded-xl px-4 py-3 text-white text-sm placeholder-gray-600 focus:outline-none focus:border-[#00FF88]/50 transition-colors"
                />
              </div>
              <div className="flex flex-col gap-2">
                <label className="text-gray-400 text-sm font-medium">
                  Mensaje <span className="text-gray-600">(máx. 500 caracteres)</span>
                </label>
                <textarea
                  name="message"
                  required
                  maxLength={500}
                  rows={5}
                  placeholder="Escribe tu mensaje aquí..."
                  className="bg-[#1a1a1a] border border-white/10 rounded-xl px-4 py-3 text-white text-sm placeholder-gray-600 focus:outline-none focus:border-[#00FF88]/50 transition-colors resize-none"
                ></textarea>
              </div>
              {status === 'error' && (
                <p className="text-[#FF6B35] text-sm text-center">
                  Ocurrió un error. Por favor intenta nuevamente.
                </p>
              )}
              <button
                type="submit"
                disabled={status === 'loading'}
                className="w-full bg-gradient-to-r from-[#00FF88] to-[#00cc6a] text-black font-black text-base py-4 rounded-xl hover:scale-[1.02] transition-all duration-300 cursor-pointer whitespace-nowrap disabled:opacity-60 disabled:cursor-not-allowed"
              >
                {status === 'loading' ? 'Enviando...' : 'Enviar mensaje →'}
              </button>
            </form>
          )}
        </div>
      </div>
    </section>
  );
}
